import {BaseCachedService} from './Core/BaseCachedService';

class SurveyAnswerPlantQuantityTypeService extends BaseCachedService {
    get Url() { return super.Url + "/surveyAnswerPlantQuantityTypes"; }
}

export const service = new SurveyAnswerPlantQuantityTypeService();

